import { useEffect } from 'react';

function useOutsideClick(element, callback) {
    const handleClickOutside = (event) => {
        if (element && !element.current.contains(event.target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [element, callback]);
}

export default useOutsideClick;
